const RESIZE_OBSERVER_LOOP_RE =
  /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

let installed = false;

export const isResizeObserverLoopError = (message) =>
  RESIZE_OBSERVER_LOOP_RE.test(message || "");

/**
 * Chromium fires this when a ResizeObserver callback changes layout in the same frame.
 * It is benign but webpack-dev-server shows it as a runtime overlay error.
 */
export const suppressResizeObserverLoopError = () => {
  if (installed || typeof window === "undefined") return;
  installed = true;

  const stop = (event) => {
    if (isResizeObserverLoopError(event?.message)) {
      event.stopImmediatePropagation?.();
    }
  };

  window.addEventListener("error", stop, true);

  const nativeConsoleError = console.error;
  console.error = (...args) => {
    const first = args[0];
    const message = typeof first === "string" ? first : first?.message;
    if (isResizeObserverLoopError(message)) return;
    nativeConsoleError.apply(console, args);
  };
};
